module.exports = __webpack_public_path__ + "static/media/avatar16.13f12267.png";